import { FC } from 'react';
import { Tooltip as UITooltip } from '@/components/ui';
import { MarketingKPIs } from '../types';

interface TopContentListProps {
    marketingKPIs: MarketingKPIs | null;
}

export const TopContentList: FC<TopContentListProps> = ({ marketingKPIs }) => {
    if (!marketingKPIs?.topPieces?.length) return null;

    return (
        <div className="bg-white rounded-2xl p-6 border border-slate-100 lg:col-span-2">
            <div className="flex items-center justify-between mb-4">
                <UITooltip content="Your best-performing posts based on how many people clicked them relative to how many saw them." position="right">
                    <h3 className="text-xs font-semibold text-slate-800">Top Performing Content</h3>
                </UITooltip>
                <span className="text-[10px] text-slate-400">by CTR</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {marketingKPIs.topPieces.slice(0, 6).map((piece, i) => (
                    <div key={piece.id} className="p-4 bg-slate-50 rounded-xl">
                        <div className="flex items-start gap-3">
                            <span className="w-6 h-6 rounded-full bg-white flex items-center justify-center text-[10px] font-bold text-slate-500 border border-slate-200">
                                {i + 1}
                            </span>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs font-medium text-slate-700 line-clamp-2">{piece.title}</p>
                                <div className="flex items-center gap-3 mt-2">
                                    <span className="text-[10px] text-slate-400">{piece.impressions.toLocaleString()} views</span>
                                    <span className="text-[10px] font-bold text-emerald-600">{(piece.ctr * 100).toFixed(1)}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
